<div class="avd-code-example-header">
    <code>{{ packageName }}</code>
    <div class="avd-code-example-header__links">
        @if (getStartedLink) {
            <a [routerLink]="getStartedLink">Getting started</a>
        }
        @if (storybookLink) {
            <a [href]="storybookLink" target="_blank">Storybook</a>
        }
        @if (repoLink) {
            <a [href]="repoLink" target="_blank">Repo</a>
        }
    </div>
</div>
